/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISmartListAPI, ISmartListProductsAPI } from "../models/smarListModels";
/* Project Import will be here */


export const addSmartListApi = (data: ISmartListAPI) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/AddOrderTemplate`,
    data
  };
  return post(request);
};

/* Get smartList data*/
export const getSmartListApi = () => {
    const request: IRequest = {
      subUrl: `/SalesOrder/OrderTemplate`
    };
    return post(request);
  };
  
// Get smartList products

export const getSmartListProductsApi = (data: ISmartListProductsAPI) => {
    const request: IRequest = {
      subUrl: `/SalesOrder/OrderTemplateDetail`,
      data
    };
    return post(request);
  };

// Delete smartList 
export const DeleteSmartListProductsApi = (data: ISmartListProductsAPI) => {
    const request: IRequest = {
      subUrl: `/SalesOrder/DeleteOrderTemplate`,
      data
    };
    return post(request);
  };

